module.exports = __webpack_public_path__ + "img/开关D1.e179e74c.png";